import Enum from './Enum';
// TODO split and move this stuff to appropriate actions, storing all shit to one file was pretty stupid idea
import * as networkActionPrefixes from './networkActionPrefixes';

export const RequestStatus = Enum('UNSYNCED', 'PENDING', 'SUCCEEDED', 'FAILED');


export const NetworkActionPrefix = Enum(networkActionPrefixes);

// each prefix in networkActionPrefixes produces 4 actions below, you don't have to define them manually
// MY_NA_PREFIX = 'MY_NA' -> 'MY_NA', 'MY_NA_PENDING', 'MY_NA_SUCCESS', 'MY_NA_FAIL'

export const ActionType = Enum(
    ...Object.keys(networkActionPrefixes).reduce((r, k) => r.concat([
        networkActionPrefixes[k],
        `${networkActionPrefixes[k]}_PENDING`,
        `${networkActionPrefixes[k]}_SUCCESS`,
        `${networkActionPrefixes[k]}_FAIL`
    ]), []),
    'SET_WEB_SOCKET_STATUS',
    'ADD_ENTITY_CHANGE',
    'DROP_ENTITY_CHANGE',
    'VOID_SESSION',
    'VOID_ALL_DATA',
    'VOID_GENERAL_SETTINGS',
    'VOID_ALL_USERS',
    'VOID_ALL_MICROSOFT_TEAMS_BOT_LINKED_CONVERSATIONS',
    'INITIALIZE_NEWSFEED',
    'DROP_NEWSFEED',
    'REVERT_DASHBOARD_BLOCK',
    'SET_MARKET_WATCH_URL',
    'SET_MARKET_WATCH_TYPE',
    'SET_MARKET_WATCH_SUGGESTIONS',
    'SET_MARKET_WATCH_HIGHLIGHT_SELECTOR',
    'SET_MARKET_WATCH_EXTEND',
    'SET_MARKET_WATCH_NAME',
    'SET_MARKET_WATCH_CATEGORY',
    'SET_MARKET_WATCH_SELECTOR',
    'SET_MARKET_WATCH_PESTEL_AREA',
    'SET_MARKET_WATCH_SWOT_TOPIC',
    'SET_MARKET_WATCH_PERSONAL_TOPIC',
    'SET_MARKET_WATCH_TREND_TOPIC',
    'SET_MARKET_WATCH_STAKEHOLDER_ID',
    'SET_MARKET_WATCH_COMPANY_LEGAL_ENTITY_ID',
    'SET_MARKET_WATCH_COMPANY_FUNCTION_ID',
    'SET_MARKET_WATCH_MODERATOR',
    'SAVE_MARKET_WATCH',
    'EDIT_TREND_NEW_COMMENT',
    'SET_MARKET_RSS_SETTINGS_NAME',
    'SET_MARKET_RSS_SETTINGS_TARGET_URL',
    'SET_MARKET_RSS_SETTINGS_PESTEL_AREA',
    'SET_MARKET_RSS_SETTINGS_STAKEHOLDER_ID',
    'SET_MARKET_RSS_SETTINGS_COMPANY_LEGAL_ENTITY_ID',
    'SET_MARKET_RSS_SETTINGS_COMPANY_FUNCTION_ID',
    'SET_MARKET_RSS_SETTINGS_MODERATOR',
    'SET_MARKET_RSS_SETTINGS_SWOT_TOPIC',
    'SET_MARKET_RSS_SETTINGS_PERSONAL_TOPIC',
    'SET_MARKET_RSS_SETTINGS_TREND_TOPIC',
    'SAVE_MARKET_RSS_SETTING',
    'MARKET_RSS_SETTING_OPEN_FOR_EDIT',
    'VALIDATE_EDITABLE_RSS_SETTING_INPUTS',
    'SHOW_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE',
    'CLOSE_MODAL_WINDOW_ON_RSS_SETTINGS_PAGE',
    'CLOSE_ALL_MODAL_WINDOWS_ON_RSS_SETTINGS_PAGE',
    'SHOW_MARKET_WATCH_DETAILS',
    'CLOSE_MARKET_WATCH_DETAILS',
    'MARKET_WATCH_CHANGE_DETAIL_MODAL_CONTENT',
    'RESET_ORGANIZATION_AUTOCOMPLETE',
    'ADD_TO_NOTIFICATIONS_LOADED_IN_REAL_TIME_COUNT',
    'FINISH_WELCOME_GUIDE_STEP',
    'VOID_CORPORATE_STRUCTURE',
    'VOID_DASHBOARD_INDICATOR_DATA',
    'FAILED_API_RESPONSE',
    'HIDE_GLOBAL_ERROR_DIALOG',
    'VOID_MASTER_SEARCH_RESULTS',
    'DROP_SEARCH_RESULTS_FROM_BING',
    'RESET_DECISION_TOPIC_SUGGESTIONS',
    'DROP_PENDING_USERS',
    'DROP_ORGANIZATION_FINANCIAL_INFORMATION',
    'DROP_STAKEHOLDER_NEWS_PREVIEW',
    'VOID_BENCHMARK_SESSION_COMMENT',
    'VOID_BENCHMARK_SESSION_PARTICIPANT',
    'VOID_BENCHMARK_SESSION_DIMENSION',
    'VOID_BENCHMARK_SESSION_SCALE',
    'VOID_BENCHMARK_SESSION_SUBJECT_REPORT',
    'VOID_BENCHMARK_SESSION_VALUE_REPORT',
    'EDIT_STRATEGY_DIAGRAM_VIEWPORT_BOUNDS',
    'VOID_ALL_DASHBOARD_PAGES',
    'DROP_SPREADSHEET_IMPORTED_RESULTS',
    'DROP_SPREADSHEET',
    'REVERT_GOOGLE_ANALYTICS_SETTINGS',
    'VOID_ALL_ERP_SYNC_PRODUCTS_SLICES',
    'VOID_ALL_ERP_SYNC_CUSTOMERS_SLICES',
    'DROP_GENERATED_SHEET',
    'VOID_MAP_DATA_REPORT',
    'VOID_ALL_PERFORMANCE_INDICATORS',
    'VOID_ALL_SWOT_VOTE_BATCHES',
    'VOID_ALL_SWOT_COMMENTS',
    'VOID_ALL_SWOT_SESSIONS',
    'VOID_ALL_SWOT_TOPICS',
    'VOID_ALL_INTEGRATION_SOURCE_COMPANY_STATUSES',
    'VOID_ALL_RAW_DATA_SOURCES',
    'SET_GOAL_CUSTOM_JOURNEY_RANGE',
    'SET_STRATEGY_NAVIGATION_HISTORY',
    'SET_TEAM_CUSTOM_ROADMAP_RANGE',
    'SET_COMPANY_FUNCTION_CUSTOM_JOURNEY_RANGE',
    'SET_COMPANY_VIRTUAL_TEAM_CUSTOM_JOURNEY_RANGE',
    'SET_USER_CUSTOM_ROADMAP_RANGE',
    'SET_MILESTONE_CUSTOM_ROADMAP_RANGE',
    'DROP_INTEGRATION_FINANCIAL_FILES_RESULT',
    'VOID_ALL_FINANCIAL_INDICATORS',
    'VOID_FINANCIAL_INDICATOR_DATA',
    'SET_STRATEGY_PLANNER_EXPANDED_NODES',
    'SET_STRATEGY_TIMELINE_COLLAPSED_GOALS',
    'VOID_ERP_DIMENSION_MAPPING',
    'DROP_ERP_FINANCIAL_INTEGRATION_TEST_RESULT',
    'VOID_ALL_MEETINGS',
    'DROP_DOWNLOADED_FILE',
    'DROP_AGENDA_NAVIGATION_HISTORY',
    'SET_AGENDA_FILTER',
    'ADIT_ALL_WORKSPACE_MINDMAP_NODE_CUSTOMS',
    'CHANGE_SESSION_TO',
    'REVERT_SESSION_BACK'
);

export const WebSocketStatus = Enum({
    UNINITIALIZED: 'UNINITIALIZED',
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED'
});

export const NewsfeedCategory = Enum({
    USER: 1,
    RSS: 2,
    TABLE_WATCH: 3,
    FUNDING: 6,
    PATENT: 7,
    JOB: 8,
    DOMAIN: 9,
    STRUCTURED_WATCH: 10,
    TEXT_WATCH: 11,
    HILMA_TENDER: 12,
    BING: 13,
    BISNODE_FINANCIALS: 14,
    TWITTER: 15
});

export const NewsEntryEntryStatus = Enum({
    RAW: 1,
    DELETED: 2,
    APPROVED: 3
});

export const NewsEntryUserStatus = Enum({
    RANKING: 3,
    RANKED: 4,
    SKIPPED: 5
});

export const PeriodType = Enum({
    DAY: 1,
    WEEK: 2,
    MONTH: 3,
    QUARTER: 5,
    YEAR: 4
});

export const SortOrder = Enum({
    UNSPECIFIED: -1,
    ASCENDING: 0,
    DESCENDING: 1
});

export const NewsfeedGroupMode = Enum({ PESTEL: 1, IMPORTANCE: 2 });

export const NewsfeedSortMode = Enum({
    AGE: 1,
    POPULARITY: 2
});

export const DashboardBlockType = Enum({
    CARTESIAN: 1,
    COMPARISON_COLUMN: 2,
    NEWSFEED: 4,
    PIE: 6,
    SOLID_GAUGE: 7,
    ACTION: 8,
    COMPARISON_BAR: 9,
    NUMBER: 10,
    EXTERNAL: 13,
    MARKET_OVERVIEW: 14,
    POLL: 15,
    TABLE: 16,
    BUBBLE: 17,
    GOOGLE_SHEET: 18,
    CASHFLOW: 19,
    POWER_BI: 20,
    CUSTOM_TABLE: 21,
    SCENARIO_CASHFLOW: 22,
    STRATEGY: 23,
    MILESTONE: 24
});

export const CartesianSerieType = Enum({
    LINE: 1,
    COLUMN: 2,
    STACKED: 3,
    GROUPED: 5,
    AREA: 4,
    AREA_RANGE: 6
});

export const ComparisonColumnSerieType = Enum({
    COLUMN: 2,
    STACKED: 3,
    POINT: 9
});

export const ComparisonBarSerieType = Enum({
    BAR: 2,
    STACKED: 3
});

export const DashboardCartesianAxis = Enum({
    LEFT: 1,
    RIGHT: 2
});

export const SWOTArea = Enum({
    S: 1,
    W: 2,
    O: 3,
    T: 4
});

export const WatchType = Enum({
    NONE: 0,
    STRUCTURED: 1,
    TABLE: 2,
    TEXT: 3
    // IMAGE: 4
});

export const TrackingLevel = Enum({
    PRODUCT: 1,
    GEO_AREA: 2,
    CUSTOMER: 3,
    TRACKING_LEVEL_1: 4,
    TRACKING_LEVEL_2: 5,
    TRACKING_LEVEL_3: 6,
    TRACKING_LEVEL_4: 7,
    COMPANY_LEGAL_ENTITY: 8,
    COMPANY_FUNCTION: 9
});

export const MarketScopeType = Enum({
    FINLAND: 1,
    GLOBAL: 2
});

export const SWOTSortMode = Enum('RATING', 'UPDATE');

export const ChangeType = Enum({
    CREATED: 1,
    CHANGED: 2,
    DELETED: 3
});

export const InteractiveMapDisplayMode = Enum('UNDEFINED', 'NEW_CUSTOMERS', 'GEOJSON_TEST');

export const HTTPStatusCode = Enum({
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503
});

export const DBBoolean = {
    NULL: 0,
    TRUE: 1,
    FALSE: 2
};

Object.defineProperties(DBBoolean, {
    'toNative': {
        configurable: false,
        enumerable: false,
        writable: false,
        value: dbBool => dbBool === DBBoolean.TRUE ? true : dbBool === DBBoolean.FALSE ? false : undefined
    },
    'fromNative': {
        configurable: false,
        enumerable: false,
        writable: false,
        value: bool => bool === true ? DBBoolean.TRUE : bool === false ? DBBoolean.FALSE : undefined
    }
});

export const PerformanceIndicatorDimension = Enum({
    ACTUAL: 1,
    BUDGET: 2,
    FORECAST: 3,
    GOAL: 4
});

export const PerformanceIndicatorPointCalculation = Enum({
    VALUE: 1,
    YEAR_CUMULATIVE: 2,
    FISCAL_PERIOD_CUMULATIVE: 5,
    ROLLING: 3,
    YEAR_TOTAL: 6,
    CHANGE: 4,
    TOTAL: 7,
    FISCAL_PERIOD_TOTAL: 8,
    CUMULATIVE: 9,
    LAST_TWELVE_MONTHS: 10
});

export const PerformanceIndicatorComparisonTarget = Enum({
    ACTUAL: 1,
    BUDGET: 2,
    FORECAST: 3,
    GOAL: 4,
    PREVIOUS: 5,
    PREVIOUS_YEAR: 6,
    TWO_YEARS_AGO: 7,
    THREE_YEARS_AGO: 8,
    INDICATOR: 9
});

export const PerformanceIndicatorComparisonCalculation = Enum({
    ABSOLUTE: 1,
    RELATIVE: 2,
    VALUE: 3,
    PORTION: 4,
    DIVISION: 5
});

export const PerformanceIndicatorPollValueAggregationType = Enum({
    SUM: 1,
    AVERAGE: 2
});

export const PerformanceIndicatorPollValueType = Enum({
    NUMERIC: 1,
    SCALE: 2
});

export const PollQuestionType = Enum({
    NUMERIC: 1,
    SCALE: 2,
    TEXT: 5,
    MULTIPLE_NUMERIC: 6
});

export const PollTargetUser = Enum({
    ALL: 0,
    WITH_FUNCTION_ID: 1,
    WITH_USER_ID: 2
});

export const InvalidScaleValueType = Enum({
    DUPLICATE_TITLE: 1,
    DUPLICATE_VALUE: 2,
    VALUE_IS_NOT_INTEGER: 3,
    TITLE_IS_EMPTY: 4,
    VALUE_IS_ZERO: 5
});

export const NewsEntryFilterPeriod = Enum({
    ALL: 0,
    WEEK: 1,
    MONTH: 2,
    QUARTER: 3,
    HALF_YEAR: 4,
    YEAR: 5,
    TWO_YEARS: 6,
    AUTO: 500,
    CUSTOM: 1000
});

export const UserDataVisibilityType = Enum({
    NONE: 0,
    ALL: 1,
    SELECTION: 2
});

export const WelcomeGuideStep = Enum('INTRODUCTION', 'PASSWORD', 'MOBILE', 'PROFILE');

export const SystemLanguage = Enum({
    FINNISH: 1,
    ENGLISH: 2,
    SWEDISH: 3
});

export const IntegrationDataMappingDimension = Enum({
    COMPANY_FUNCTION: 1,
    COMPANY_LEGAL_ENTITY: 2,
    CUSTOMER: 3,
    PRODUCT: 4,
    SEGMENT: 5,
    TRACKING_LEVEL_3: 6,
    TRACKING_LEVEL_1: 7,
    TRACKING_LEVEL_2: 8,
    TRACKING_LEVEL_4: 9,
    GEO_AREA: 10
});

export const IntegrationDataMappingMatchRule = Enum({
    EQUALS: 1,
    GREATER_THAN: 2,
    LESSER_THAN: 3,
    SAME_OR_GREATER: 4,
    SAME_OR_LESSER: 5,
    CONTAINS: 6,
    STARTS_WITH: 7,
    ENDS_WITH: 8,
    IS_NOT_EMPTY: 9,
    LENGTH_GREATER_THAN: 10
});

export const IntegrationDataMappingType = Enum({
    INVOICING_DATA: 1,
    ACCOUNTING_DATA: 2
});

export const IntegrationDataMappingSource = Enum({
    CONSTANT: 1,
    ACCOUNTING_DATA_DIMENSION1: 2,
    ACCOUNTING_DATA_DIMENSION2: 3,
    ACCOUNTING_DATA_DIMENSION3: 4,
    ACCOUNTING_DATA_DESCRIPTION: 5,
    ACCOUNTING_DATA_ACCOUNT_NUMBER: 6,
    ACCOUNTING_DATA_DEBET: 7,
    ACCOUNTING_DATA_KREDIT: 8,
    INVOICING_DATA_TOTAL_NET_SUM: 9,
    INVOICING_DATA_PRODUCT_CODE: 10,
    INVOICING_DATA_PRODUCT_NAME: 11,
    INVOICING_DATA_DIMENSION1: 12,
    INVOICING_DATA_DIMENSION2: 13,
    INVOICING_DATA_DIMENSION3: 14,
    INVOICING_DATA_ACCOUNTING_SUGGESTION: 15,
    INVOICING_DATA_INVOICING_CUSTOMER_EXTERNAL_ID: 16,
    INVOICING_DATA_PRODUCT_SYNC_GROUP_NAME: 17,
    INVOICING_DATA_CUSTOMER_SYNC_GROUP_NAME: 18,
    INVOICING_DATA_SELLER_IDENTIFIER: 19,
    INVOICING_DATA_INVOICING_CUSTOMER_NAME: 20,
    NETVISOR_INTEGRATION_CUSTOMER_SYNC_COUNTRY_CODE_ISO3166: 21,
    INVOICING_DATA_INVOICE_COMMENT: 22,
    ACCOUNTING_DATA_DIMENSION4: 23,
    ACCOUNTING_DATA_DIMENSION5: 24,
    ACCOUNTING_DATA_DIMENSION6: 25
});

export const RuleDisplayType = Enum('NONE', 'FILTER', 'HIGHLIGHT');

export const NewsfeedUpdateType = Enum('CHANGE_MODE', 'CHANGE_FILTER', 'LOAD_MORE');

export const Country = Enum({
    // country list is pretty huge, but currently we need only to distinguish Finland from other world, so just a slice here and no synchronicity check
    FI: 72
});


export const UserNotificationEventSource = Enum({
    NEWSENTRY_COMMENT: 1,
    NEWSENTRY_GAIN_CONTRIBUTORS: 2,
    NEWSENTRY_STATUS_CHANGE: 3,
    NEWSENTRY_QUALIFICATION_STATUS_CHANGE: 4,
    NEWSENTRY_SWOT_SELECTION: 5,
    NEWSENTRY_NEW_ENTRY_IN_FEED: 6,
    DASHBOARD_BLOCK_QUESTION: 7,
    DASHBOARD_BLOCK_RESPONSE: 8,
    INDICATOR_POLL_NEW: 9,
    SWOT_SESSION_NEW: 10,
    SWOT_SESSION_NEW_TOPIC: 11,
    SWOT_TOPIC_NEW_COMMENT: 12,
    NEW_SUBACTION: 13,
    STRATEGY_ACTION_CLOSED: 14,
    NEW_STRATEGY_ACTION_COMMENT: 15,
    WEEKLY_MARKET_RECAP: 16,
    NEWSROOM_HIGHLIGHTS: 17,
    WEEKLY_GOAL_PROGRESS_REMINDER: 18,
    MONTHLY_GOAL_STATUS_UPDATE_REMINDER: 19,
    GOAL_ACTIVITY_CREATION_AND_COMMENT: 20,
    NEWS_ENTRY_UPDATE: 21,
    INSIGHT_COMMENT_AND_FEEDBACK: 22,
    BUDGET_AND_FORECASTING_PROCESS: 23,
    REPORTS: 24,
    MEETING_NOTIFICATIONS: 25,
    WORKSHOP_DISCUSSION: 26,
    POLLS: 27,
    INTEGRATION_ERRORS: 28,
    SUMMARIES: 29
});

export const BingCognitiveFreshness = Enum({
    UNDEFINED: 0,
    DAY: 1,
    WEEK: 2,
    MONTH: 3
});

export const BingCognitiveMarket = Enum({
    ENGLISH_USA: 1,
    FINNISH_FINLAND: 2,
    SWEDISH_SWEDEN: 3,
    SPANISH_ARGENTINA: 4,
    ENGLISH_AUSTRALIA: 5,
    GERMAN_AUSTRIA: 6,
    DUTCH_BELGIUM: 7,
    FRENCH_BELGIUM: 8,
    PORTUGUESE_BRAZIL: 9,
    ENGLISH_CANADA: 10,
    FRENCH_CANADA: 11,
    SPANISH_CHILE: 12,
    DANISH_DENMARK: 13,
    FRENCH_FRANCE: 14,
    GERMAN_GERMANY: 15,
    CHINESE_HONG_KONG: 16,
    ENGLISH_INDIA: 17,
    ENGLISH_INDONESIA: 18,
    ITALIAN_ITALY: 19,
    JAPANESE_JAPAN: 20,
    KOREAN_KOREA: 21,
    ENGLISH_MALAYSIA: 22,
    SPANISH_MEXICO: 23,
    DUTCH_NETHERLANDS: 24,
    ENGLISH_NEW_ZEALAND: 25,
    NORWEGIAN_NORWAY: 26,
    CHINESE_CHINA: 27,
    POLISH_POLAND: 28,
    PORTUGUESE_PORTUGAL: 29,
    ENGLISH_PHILIPPINES: 30,
    RUSSIAN_RUSSIA: 31,
    ARABIC_SAUDI_ARABIA: 32,
    ENGLISH_SOUTH_AFRICA: 33,
    SPANISH_SPAIN: 34,
    FRENCH_SWITZERLAND: 35,
    GERMAN_SWITZERLAND: 36,
    CHINESE_TAIWAN: 37,
    TURKISH_TURKEY: 38,
    ENGLISH_UK: 39,
    SPANISH_USA: 40
});

export const BingSearchType = Enum({
    NEWS: 1,
    WEB: 2
});

export const PerformanceIndicatorValueSource = Enum({
    FINANCIAL_SYSTEM: 1,
    POLL: 2,
    MANUAL: 3,
    GOOGLE_SHEETS: 4,
    THIRD_PARTY_SYSTEM: 5,
    CALCULATED: 6,
    SUMMED: 7,
    GOOGLE_ANALYTICS: 8,
    NETVISOR_BILLING: 9
});

export const NewsEntrySourceType = Enum({
    STRUCTURED_DATA: 1,
    TABLE: 2,
    TEXT: 3,
    RSS: 4,
    BING: 5,
    STAKEHOLDER: 7
});

export const NewsEntrySourceCategory = Enum({
    OPPORTUNITIES: 1,
    THREATS: 2,
    STAKEHOLDERS: 5,
    TRENDS: 9,
    UNCATEGORIZED: 0
});

export const MasterSearchItemType = Enum({
    INDICATOR: 1,
    NEWS_ENTRY: 2,
    CUSTOMER: 3,
    TRACKING_LEVEL_1: 4,
    TRACKING_LEVEL_2: 5,
    TRACKING_LEVEL_3: 6,
    TRACKING_LEVEL_4: 7,
    PEOPLE: 8,
    SWOT_TOPIC: 9,
    DASHBOARD_PAGE_BLOCK: 12,
    COMPANY_FUNCTION: 13,
    SWOT_SESSION: 14,
    ORGANIZATION: 15,
    BREAKTHROUGH: 16,
    ACTION: 17
});

export const MeetingSectionStatus = Enum({
    DRAFT: 1,
    DONE: 2
});

export const MeetingStatus = Enum({
    PREPARATION: 1,
    FAMILIARIZE: 2,
    RUNNING: 3,
    REVIEW: 4,
    SIGNING: 5,
    ARCHIVED: 6
});

export const MeetingMinutesContentType = Enum({
    TOPIC_DESCRIPTION: 1,
    COMMENTS: 2,
    NOTES: 3,
    DECISIONS: 4,
    TASKS: 5,
    PDF_ATTACHMENTS: 6,
    TOPIC_IMAGES: 7
});

export const AccessModule = Enum({
    PERFORMANCE_MONITORING: 1,
    MARKET_ENVIRONMENT_MONITORING: 2,
    LEADING_OF_OPERATIONS: 3,
    INTELLIGENT_AGENDA: 4
});

export const AccessFunctionality = Enum({
    DASHBOARDS_AND_REPORTS: 1,
    FORECASTS: 2,
    POLLS: 4,
    INDICATOR_MANAGEMENT: 5,
    DATA_SOURCES: 6,
    NEWS: 7,
    MARKET_ANALYSES: 8,
    NEWS_SOURCES: 9,
    STAKEHOLDERS: 10,
    AGENDA_AND_ACTIONS: 11,
    STRATEGY_WORK: 12,
    BILLING_ANALYSES_AND_ALERTS: 13
});

export const AccessType = Enum({
    READ: 1,
    WRITE: 2,
    NO_ACCESS: 3
});

export const AccessProfile = Enum({
    CORE: 1,
    MARKET_INSIGHTS: 2,
    INSIGHT_READONLY: 3,
    ALL: 4
});

export const SystemUserType = Enum({
    NORMAL_USER: 1,
    PARTICIPATOR: 2,
    WORKSHOP_PARTICIPATOR: 3
});

export const SystemUserRole = Enum({
    UNAVAILABLE: 1,
    BOARD_MEMBER: 2,
    CEO: 3,
    MANAGEMENT_TEAM_MEMBER: 4,
    STRATEGY_FACILITATOR: 5,
    MANAGER: 6,
    EXPERT: 7
});

export const ProductPackage = Enum({
    OLD: 1,
    ADVISORY360: 2,
    AGENDA360: 3,
    MONTHLY_MODULES: 4,
    USER_ROLE_BASED_BILLING: 5,
    SMART_STRATEGY: 6,
    LIGHTWEIGHT_MUNICIPALITY: 7,
    GOALWISOR: 8
});

export const UserRoleBillingUserType = Enum({
    FACILITATOR: 1,
    MANAGER: 2,
    PARTICIPANT: 3
});

export const PersistentNewsfeedKey = Enum(
    'DEFAULT',
    'TASKS',
    'RANKING',
    'TOP_NEWS',
    'LIVING_STRATEGY_DASHBOARD',
    'TREND_CHART',
    'STAKEHOLDERS',
    'MARKET_MAP'
);

export const NewsEntrySize = Enum('SMALL', 'BIG');

export const DecisionStatus = Enum({
    WAITING_FOR_ACKNOWLEDGEMENT: 1,
    CLOSED: 2
});

export const DecisionFollowUpAction = Enum('CONFIRM_ACTION', 'FORWARD_ACTION_TO_ANOTHER_USER');

export const PersistentSearchResultsFromBingKey = Enum('NEWS_WATCH');

export const PersistentFinancialInformationKey = Enum(
    'MARKET_PLAYER_EDITOR_POPUP',
    'MARKET_PLAYER_DETAILS',
    'STAKEHOLDER_EDITOR_POPUP',
    'STAKEHOLDER_DETAILS'
);

export const ManagementAgendaColumnContentType = Enum('NEW_INITIATIVES', 'IN_PREPARATION', 'UPCOMING_MEETINGS', 'DECISIONS');

export const NotificationSendingTimeType = Enum({
    BEGINNING: 1,
    MIDDLE: 2,
    END: 3
});

export const PerformanceIndicatorRelativePeriod = Enum({
    PREVIOUS: 1,
    CURRENT: 2,
    NEXT: 3,
    NEXT_PLUS_ONE: 4
});

export const UserEngagementEventType = Enum({
    VISITED_DASHBOARD_PAGE: 1
});

export const StakeholderNewsWatchFilterLevel = Enum({
    LOOSE: 1,
    MEDIUM: 2,
    STRICT: 3
});

export const PerformanceIndicatorCollectionType = Enum({
    GROUPS: 1,
    ALL: 2
});

export const IndicatorPageGroupSource = Enum({
    PERFORMANCE_PERSPECTIVE: 1,
    TRACKING_LEVEL: 2
});

export const UrlContentType = Enum({
    INVALID_URL: 1,
    VALID_URL: 2,
    VALID_RSS_FEED_URL: 3
});

export const IntegrationSource = Enum({
    NETVISOR: 1,
    GOOGLE_ANALYTICS: 2,
    GOOGLE_SHEETS: 3,
    EXCEL: 4,
    SIE_UPLOAD: 5,
    PIPEDRIVE: 6,
    PROCOUNTOR: 7,
    CRM_SERVICE: 8,
    ACUTE: 9,
    JIRA: 10,
    HILMA_TENDERS: 11,
    VALUEFRAME: 12,
    FIVALDI: 13,
    LEMONSOFT: 14,
    MICROSOFT_TEAMS: 15,
    TOGGL: 16,
    V10: 17,
    SEVERA: 18,
    NOVA_SDK: 19,
    L7: 20,
    E_ACCOUNTING: 21
});

export const IntegrationSourceStatus = Enum({
    READY: 1,
    IN_PROGRESS: 2,
    IN_ERROR: 3,
    CONFIGURATION_PENDING: 4
});

export const ApprovalScope = Enum({ 'USER': 1, 'FUNCTION': 2, 'ALL': 3 });

export const RankingScope = Enum({ 'AUTHORED': 1, 'UNRANKED': 2, 'CONTRIBUTED': 3, 'ALL': 4 });

export const GoogleOAuthSourceType = Enum('NEW', 'EXISTING', 'INTERNAL');

export const NetvisorSyncDefaultHandleType = Enum({
    CREATE_AND_LINK_GROUP: 1,
    MAP_TO_OTHER: 2,
    DO_NOTHING: 3
});

export const PerformanceIndicatorDateRange = Enum({ 'PAST': 1, 'FUTURE': 2, 'ROLLING': 3, 'CUSTOM': 4, 'YEAR': 5, 'FISCAL_PERIOD': 6 });

export const MarketWatchDetailModalContent = Enum('DETAILS', 'DELETE_CONFIRMATION');

export const DashboardStrategicActionViewType = Enum({
    CREATED_BY_ME: 1,
    ASSIGNED_TO_ME: 2,
    IN_PARTICIPATED_STRATEGIES: 3,
    ALL_ACTIONS: 4
});

export const DashboardPageBlockSerieOrder = Enum({
    NAME: 1,
    VALUE_ASC: 2,
    VALUE_DESC: 3
});

export const ERPDimensionSyncType = Enum({
    NO_ACTION: 1,
    SYNC_DIMENSION_AND_TARGET: 2
});

export const PerformanceIndicatorValueDependencyRule = Enum({
    SUM: 1,
    AVERAGE: 2,
    LAST_VALUE: 3
});

export const IndicatorGeneralSettingsView = Enum('DEFAULT', 'DIMENSIONS', 'INDICATOR_NAMES', 'ORGANIZATION_LEVELS');

export const PerformancePerspective = Enum({
    FINANCIAL: 1,
    CUSTOMER: 2,
    INTERNAL_PROCESSES: 3,
    LEARNING_AND_GROWTH: 4,
    OTHER: 5
});

export const PerformancePerspectiveGroup = Enum({
    ASSETS: 1,
    LIABILITIES_AND_EQUITY: 2,
    PROFIT_AND_LOSS: 3,
    CASHFLOW: 4,
    PROFITABILITY: 5,
    CUSTOMER: 6,
    MARKET: 7,
    GROWTH: 8,
    PROCESS: 9,
    EFFICIENCY: 10,
    PEOPLE: 11,
    GOALS: 12,
    ACTIONS: 13,
    UNKNOWN: 10000
});

export const PerformanceIndicatorSystemType = Enum({
    FINANCIAL: 1,
    FINANCIAL_OVERVIEW: 2,
    INTEGRATION: 3,
    DEFAULT: 4,
    USER: 5,
    INTERNAL: 6
});

export const CorporateStructureSortMode = Enum({
    NAME: 1,
    VALUE_ASC: 2,
    VALUE_DESC: 3
});

export const StrategicProgramStatus = Enum({
    OPEN: 1,
    CLOSED: 2,
    DRAFT: 3
});

export const MeetingPresentationDataSource = Enum({
    MEETINGS: 1,
    TEMPLATES: 2
});

export const StrategyPageBlockType = Enum({
    STRATEGIC_GOALS: 1,
    STRATEGY_SELECTIONS: 2,
    KPIS: 3,
    STRATEGIC_ACTIONS: 4,
    INITIATIVES: 5,
    DASHBOARD_BLOCK: 6,
    MEMO_BLOCK: 7
});

export const LastFinancialPeriodType = Enum({
    NOT_AVAILABLE: 1,
    MANUAL: 2,
    FINANCIAL_SYSTEM: 3,
    ROLLING: 4
});

export const SheetForecastInputMethod = Enum({
    APPLICATION: 1,
    AUTO_SHEET: 2,
    TEMPLATE_SHEET: 3,
    CUSTOM_SHEET: 4,
    LINKED_EXCEL_FILE: 5
});

export const SheetForecastFileStatus = Enum({
    PENDING: 1,
    IN_PROGRESS: 2,
    READY: 3
});

export const SheetConfigurationForecastDownloadFromSheetRule = Enum({
    NONE: 1,
    ALL_PERIODS: 2,
    STARTING_FROM_CURRENT_PERIOD: 3,
    STARTING_FROM_NEXT_PERIOD: 4,
    AFTER_LAST_CONFIRMED_FINANCIAL_NUMBERS: 5,
    UNTIL_END_OF_LAST_CONFIRMED_FINANCIAL_NUMBERS: 6
});

export const SheetConfigurationForecastUploadToSheetRule = Enum({
    NONE: 1,
    ALL_PERIODS: 2,
    UNTIL_PREVIOUS_PERIOD: 3,
    UNTIL_CURRENT_PERIOD: 4,
    LAST_CONFIRMED_FINANCIAL_NUMBERS: 5,
    FROM_BEGINNING_OF_LAST_CONFIRMED_FINANCIAL_NUMBERS: 6
});

export const PerformanceIndicatorFormulaElementType = Enum({
    PLUS: 1,
    MINUS: 2,
    PARENTHESIS_OPEN: 3,
    PARENTHESIS_CLOSED: 4,
    DIVISION_SIGN: 5,
    ASTERISK: 6,
    NUMBER: 7,
    INDICATOR: 8,
    INDICATOR_CHANGE: 9,
    FILTERED_INDICATOR: 10
});

export const PerformanceIndicatorPollStatus = Enum({
    DRAFT: 1,
    RUNNING: 2,
    PENDING: 3
});

export const AccessFunctionalityAddOn = Enum({
    INITIATIVES_MOBILE_AND_CHAT: 1,
    BUDGETING_AND_ROLLING_FORECASTS: 3,
    STAKEHOLDER_FINANCIAL_STATEMENT: 5,
    BRANDING: 6,
    CO_CREATION: 7,
    TEAM_MANAGEMENT: 8,
    EXECUTION_REVIEW: 9,
    AGENDA_HOME: 10,
    MEETINGS: 11
});

export const SheetGenerationFormDataInputType = Enum('COLLECTION', 'FORECASTING', 'UNDEFINED');

export const SheetForecastFileType = Enum({
    SUMMING: 1,
    DATA_COLLECTION: 2
});

export const StrategyRoadmapDescriptionFilter = Enum({
    ALL: 1,
    PARTICIPATING: 2
});

export const StrategyRoadmapOptionalItem = Enum({
    CLOSED_ACTIONS: 1,
    MEETINGS: 2,
    STRATEGY_WORK: 3,
    MILESTONES: 4
});

export const StrategicProgramUpdateFrequency = Enum({
    WEEK: 1,
    BIWEEKLY: 2,
    MONTH: 3,
    QUARTER: 4,
    YEAR: 5,
    NO_MANUAL_UPDATE: 6
});

export const StrategicProgramRiskLevel = Enum({
    ON_TRACK: 1,
    HAS_ISSUES: 2,
    AT_RISK: 3
});

export const GoalMetricValueType = Enum({
    ACHIEVED_ONCE: 1,
    ACHIEVED_EACH_PERIOD: 2,
    DEFINED_BY_USER: 3
});

export const RoadmapMode = Enum({
    TIMELINE: 1,
    TABLE: 2
});

export const SheetGoogleTemplateCopiedRangeValueType = Enum({
    VALUE: 1,
    FORMULA: 2,
    PROTECTED_CELL: 3,
    FORMAT: 4,
    CONFIGURATION: 5
});

export const RawDataSourceStatus = Enum({
    DRAFT: 1,
    ACTIVE: 2,
    PAUSED: 3
});

export const RawDataMappingColumnDataType = Enum({
    COMMENT_OR_DESCRIPTION: 1,
    INDICATOR: 2,
    TIME: 3,
    TRACKING_LEVEL: 4,
    VALUE: 5
});

export const RawDataSourceType = Enum({
    CSV: 1,
    EXCEL: 2,
    GOOGLE_SHEETS: 3,
    TOGGL: 4
});

export const StrategyPage = Enum('ACTIONS', 'JOURNEY', 'OVERVIEW', 'PLANNER', 'ROADMAP');

export const DecisionPollType = Enum({
    INITIATIVE: 1,
    ACTION: 2,
    MILESTONE: 3,
    SWOT: 4,
    MEETING: 5,
    INSIGHT: 6
});

export const StrategyTaxonomy = Enum({
    STRATEGY: 1,
    SELECTION: 2,
    GOAL: 3,
    CRITICAL_SUCCESS_FACTORS: 4,
    IDEAL_STATE: 5,
    MILESTONE: 6,
    ACTION: 7,
    DASHBOARD_BLOCK: 8
});

export const DashboardCopyStatusCode = Enum({
    OK: 1,
    FAILED: 2
});

export const StrategyNavigationScope = Enum('ACTIONS', 'STRATEGY');

export const MeetingSectionContentType = Enum({
    TEXT: 1,
    GRAPH: 2,
    ACTION: 3,
    MILESTONE: 4,
    SCENARIO: 5,
    OBSERVATION: 6,
    INITIATIVE: 7,
    POLL: 8,
    ATTACHMENT: 9,
    GOOGLE_DOCUMENT: 10,
    NEWS: 11,
    MARKET_TREND: 12
});

export const MeetingInvitationPeriodType = Enum({
    HOUR: 1,
    DAY: 2,
    WEEK: 3
});

export const PartnerSupportLevel = Enum({
    LEAD: 1,
    SUPPORT: 2,
    ADVISOR: 3
});

export const ExcelGenerationIndicatorDepthRule = Enum({
    ALL_LEVELS: 1,
    HIGHEST_ACCOUNT_GROUPS: 2,
    TWO_LEVELS: 3
});

export const ExcelGenerationValueWriteRule = Enum({
    NOTHING: 1,
    PREVIOUS_ACTUAL: 2,
    PREVIOUS_BUDGET: 3,
    PERIOD_ACTUAL: 4,
    PERIOD_ACTUAL_PLUS_BUDGET: 5,
    PERIOD_ACTUAL_PLUS_FORECAST: 6,
    PERIOD_BUDGET: 7,
    PERIOD_FORECAST: 8
});

export const DecisionTrackingType = Enum({
    NO_TRACKING: 1,
    TASK_TO_COMPLETE: 2,
    STRATEGIC_ACTION: 3,
    STRATEGIC_BREAKTHROUGH: 4
});

export const StrategicGoalMilestoneStatus = Enum({
    DRAFT: 1,
    ACTIVE: 2,
    ARCHIVED: 3,
    COMPLETED: 4
});

export const StrategicGoalMilestoneAchievability = Enum({
    VERY_LOW: 1,
    LOW: 2,
    MEDIUM: 3,
    HIGH: 4,
    VERY_HIGH: 5
});

export const StrategyDescriptionStatus = Enum({
    PLANNING: 1,
    ACTIVE: 3,
    ARCHIVED: 4
});

export const BusinessModelCanvasItemType = Enum({
    NOTE: 1,
    CHART: 2,
    ANALYSIS: 3
});

export const DecisionTopicStatus = Enum({
    DRAFT: 1,
    ACTIVE: 2,
    ARCHIVED: 3
});

export const BusinessModelArea = Enum({
    KEY_PARTNERS: 1,
    KEY_ACTIVITIES: 2,
    KEY_RESOURCES: 3,
    VALUE_PROPOSITIONS: 4,
    CUSTOMER_RELATIONSHIPS: 5,
    CHANNELS: 6,
    CUSTOMER_SEGMENTS: 7,
    COST_STRUCTURE: 8,
    REVENUE_STREAMS: 9
});

export const StrategyExecutionType = Enum({
    BREAKTHROUGH: 1,
    OKR: 2
});

export const StrategyPublishingLevel = Enum({
    ONLY_STRATEGY: 1,
    ALL: 2
});

export const StrategyAllowUserInviteType = Enum({
    NOT_ALLOWED: 1,
    APPROVAL: 2,
    ALLOW: 3
});

export const Category = Enum({
    MARKETS: 1,
    MODELS: 2,
    PROJECTS: 3,
    RESULTS: 4
});

export const InsightFeedKey = Enum({
    INSIGHT_FEED: 'INSIGHT_FEED',
    FILTERED_INSIGHTS: 'FILTERED_INSIGHTS'
});

export const InsightType = Enum({
    NORMAL: 1,
    BREAKTHROUGH_STATUS_UPDATE: 2,
    ACTION_STATUS_UPDATE: 3,
    BUSINESS_REVIEW: 4,
    EXECUTION_BUSINESS_REVIEW: 5
});

export const InsightCardViewType = Enum({
    FEED_PREVIEW: 1,
    FEED_FULL: 2,
    ONLY_DESCRIPTION: 3,
    DIALOG: 4,
    FULL: 5,
    BUSINESS_REVIEW_PREVIEW: 6
});

export const PageOrientation = Enum({
    PORTRAIT: 1,
    LANDSCAPE: 2
});

export const AdministrationUserType = Enum({
    ADMINISTRATOR: 1,
    SUPERUSER: 2,
    DEMO_USER: 3,
    GENERIC_POLL: 4,
    BACKGROUND_SHEET: 5,
    PUBLIC_PAGE_USER: 6
});
